export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/zonademand_MX_desktop.6ca0534b.png";